import { Link } from 'react-router-dom';

const FourOhFour = () => {
  return (
    <section
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        justifyContent: 'center',
        alignItems: 'center',
        blockSize: '80vh'
      }}
    >
      <h2>The page you are looking for does not exist.</h2>

      <Link to="/">
        <h2>Go to login page</h2>
      </Link>
    </section>
  );
};

export default FourOhFour;
